import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=42aa1804&scoped=true&"
import script from "./CloseBtn.vue?vue&type=script&lang=js&"
export * from "./CloseBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa1804",
  null
  
)

export default component.exports